<template>
  <vx-card class="min-h-screen">
		<div>
			<draggable v-model="masters.banners">
				<transition-group>
					<div v-for="banner in masters.banners" :key="banner.id" style="height: 8rem; cursor: move;" class="p-3 pr-8 flex justify-between mb-3 border-dashed rounded-lg border-2 shadow">
						<div class="w-full md:w-9/12 flex items-center pr-2 h-full">
							<img :src="getUrlOfFile(banner.image, true)" class="inline-block w-4/12 md:w-2/12 h-full object-cover" />
							<p class="w-8/12 md:w-10/12 pl-4 h5" style="overflow-wrap: anywhere;">{{banner.name}}</p> 
						</div>
						<div class="w-3/12 flex">
							<feather-icon icon='MoveIcon' svgClasses='h-5 md:h-8 w-5 md:w-8' class='ml-auto' />
						</div>
					</div>
				</transition-group>
			</draggable>
		</div>
		<div slot="footer" class="justify-center">
			<vs-button @click="save" button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
			<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
		</div>
	</vx-card>
</template>

<script>
import draggable from 'vuedraggable'
import {
	getUrlOfFile
} from '@/utils/helpers.js';
import api from '@/utils/api'
export default {
		name: 'ListUser',
		components: {
      draggable
		},
		data() {
			return {
				getUrlOfFile,
				config: {
					uri: this.$route.meta.link,
				},
				masters: {
          banners: []
				},
				models: {
					banners: []
				}
			}
		},
		created() {
			const _ = this;
			_.get();
		},
		methods: {
			get() {
				this.$axios.get(api.misc_banners)
					.then(res => {
						const {data} = res.data
						this.masters.banners = data
					})
			},
			save() {
				this.models.banners = this.masters.banners.map((banner, idx) => {
					return {
						id: banner.id,
						order: idx + 1
					}
				})
				this.$axios.post(api.bannersChangeOrder, this.models)
					.then(() => {
						this.$showToast('Success', `Success update position`,)
						this.$router.push({
							name: this.config.uri
						})
					})
					.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
			}
		},
	}
</script>

<style>

</style>